<template>
  <div id="scroll-target">
    <vs-row>
      <vs-col vs-type="flex" vs-lg="7" vs-sm="12" class="m-0 p-0"> </vs-col>
      <vs-col vs-align="flex-end" vs-lg="5" vs-sm="12" class="m-0 p-0">
        <div class="text-right hidden lg:inline-block" style="float: right">
          <!-- action table -->
          <ul class="demo-alignment pb-0" style="float: right">
            <li class="pl-4 border-0 border-l border-solid border-grey">
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
    <vs-card>
      <div class="text-left visible lg:hidden mt-2">
        <!-- action table -->
        <ul class="demo-alignment pb-0" style>
          <li>
            <vs-checkbox
              v-model="type"
              color="grey"
              vs-value="buy"
              @change="refreshTable()"
              >Email</vs-checkbox
            >
          </li>
          <li>
            <vs-checkbox
              v-model="type"
              color="grey"
              vs-value="free"
              @change="refreshTable()"
              >SMS</vs-checkbox
            >
          </li>
        </ul>
        <!-- <div class="mt-5 text-left">
        <vs-button
          class="mr-2"
          color="grey"
          type="border"
          @click="refreshTable()"
        >Apply</vs-button>
        <vs-button color="grey" type="border" @click="onExport()">
          <i class="fas fa-file-download"></i>
        </vs-button>
      </div>-->
      </div>

      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :foot-clone="true"
        no-footer-sorting
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>
        <!-- A custom formatted footer cell for field 'name' -->
        <template #foot()="data">
          <div style="font-weight:bolder; font-size:1.1rem;">
            <b>{{ data.field.foot }}</b>
          </div>
        </template>
      </b-table>
      <!--
      <data-table :columns="columns" :data="data" @onTablePropsChanged="reloadTable"></data-table>
      -->
      <div v-if="showPagination" class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} orders</div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import XLSX from "xlsx"; // import xlsx
import Service from "@/services";
export default {
  components: {},
  data: () => ({
    order_id: null,
    isBusy: false,
    showPagination: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    columns: [
      { label: "Date", key: "datetime", sortable: false, foot: "" },
      { label: "Type", key: "type", sortable: false, foot: "" },
      { label: "Message ID", key: "message_id", sortable: false, foot: "" },
      {
        label: "Provider Name",
        key: "provider_name",
        sortable: false,
        foot: ""
      },
      { label: "Requested By", key: "sent_by", sortable: false, foot: "" },
      { label: "Staff Name", key: "staff_name", sortable: false, foot: "" },
      { label: "Note", key: "log_message", sortable: false, foot: "" }
    ],
    type: ["email", "sms"]
  }),
  watch: {},
  created() {
    this.order_id = this.$route.query.o;
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e
        };

        /* filter type */
        if (this.type.length > 0) {
          data.tp = this.type;
        }

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        return Service.Report.communication(params)
          .then(res => {
            this.data = res.data;

            let footerRow = res.data[res.data.length - 1];
            for (var key in footerRow) {
              if (footerRow.hasOwnProperty(key)) {
                let index = this.columns.findIndex(x => x.key == key);
                if (index >= 0) {
                  this.columns[index].foot = footerRow[key];
                }
              }
            }
            this.data.pop();
            callback(this.data);
          })
          .catch(error => {
            callback([]);
          });
      }, 500);
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    onExport() {
      let rows = this.data.map((item, index) => {
        return {
          Date: item.datetime,
          Type: item.type,
          "Message ID": item.message_id,
          "Provider Name": item.provider_name,
          "Requested By": item.sent_by,
          "Staff Name": item.staff_name,
          Note: item.log_message
        };
      });

      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "communication_report.xlsx");
    }
  }
};
</script>
